/**
 * Reg Exp Tester
 *
 * @param {RegExp} re - regular expression to convey test with
 * @returns {function(*=, *): boolean|*}
 * @throws TypeError
 */
export default re => (value, options) => {
  if (re.test(value)) {
    return true
  } else {
    throw TypeError(options.error)
  }
}
